// One cart line per product + variation (+ the buyer's custom answer / upload), never more than that line's stock.
// The Discover tile, the store page and the product page each used to key their cart lines differently
// (`id-default-<time>` vs plain `id`), so adding the same product from two places left TWO lines that were each
// allowed up to the full stock — e.g. 5 in stock, 10 in the bag. Every cart write now passes through this.
const lineIdentity = (i) => [
  i.id,
  i.selectedVariation?.name || "",
  i.selectedCombo || "",
  i.selectedAdvanced ? JSON.stringify(i.selectedAdvanced) : "",
  i.custom_answer || "",
  i.custom_image || "",
].join("|");

export const lineStockCap = (i) => {
  const v = i.selectedVariation?.stock;
  const n = v != null ? Number(v) : (i.stock != null ? Number(i.stock) : NaN);
  return Number.isFinite(n) && n > 0 ? n : Infinity;
};

// Returns the SAME array when nothing needs changing, so it is safe to call inside an effect that sets state.
export function normalizeCart(cart) {
  if (!Array.isArray(cart)) return cart;
  const seen = new Map();
  const out = [];
  let changed = false;
  for (const raw of cart) {
    if (!raw || typeof raw !== "object") { changed = true; continue; }
    const key = lineIdentity(raw);
    const cap = lineStockCap(raw);
    const qty = Math.max(1, Number(raw.qty) || 1);
    if (seen.has(key)) {
      const first = out[seen.get(key)];
      const merged = Math.min(first.qty + qty, Math.min(lineStockCap(first), cap));
      out[seen.get(key)] = { ...first, qty: merged };
      changed = true;
    } else {
      const clamped = Math.min(qty, cap);
      if (clamped !== raw.qty) changed = true;
      seen.set(key, out.length);
      out.push(clamped !== raw.qty ? { ...raw, qty: clamped } : raw);
    }
  }
  return changed ? out : cart;
}
